import { withStyles, Divider, Tabs, Tab } from '@material-ui/core';
import React, { useState } from 'react';
import WithDrawer from '../../../Dispatch/Common/Drawer/WithDrawer';
import { compose } from 'recompose';
import MergeStopsDetails from './MergeStopsDetails';
import appConstants from '../../../../../appConstants';
import ShipmentDetails from './ShipmentDetails';

const styles = (theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    flex: 1,
    color: theme.iconColor,
    backgroundColor: theme.ModalBGColor
  },
  divider: {
    backgroundColor: theme.AppBGColor
  },
  tabContainer: {
    color: theme.TextColor,
    width: '100%'
  },
  tabRoot: {
    padding: 0,
    textTransform: 'none',
    fontSize: theme.headerTextFontSize,
    color: theme.gridTextColor,
    minWidth: 60,
    '&$tabSelected': {
      color: theme.HeaderSelectedText
    },
    '&:hover': {
      color: theme.HeaderSelectedText,
      opacity: 1
    }
  },
  tabSelected: {},
  tabIndicator: {
    display: 'none' // Hides the default MUI underline
  },
  tabLabelContainer: {
    padding: '8px 16px' // Adjust label padding
  },
  tabPanel: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex'
  },
  hiddenTabPanel: {
    display: 'none'
  }
});

const TabPanel = ({ children, value, index, classes }) => {
  return (
    <div className={`${classes.tabPanel} ${value !== index ? classes.hiddenTabPanel : ''}`}>
      {children}
    </div>
  );
};

const MergeStops = ({
  classes,
  onClose,
  selectedStops,
  glEventHub,
  mergeType,
  onMergeCompleted,
  isDuplicateCustomerTerminalLevelEnabled = false
}) => {
  const [activeTab, setActiveTab] = useState(appConstants.MERGE_STOPS_TAB_TYPE.MERGE_STOPS);
  const [mergeStopInProgress, setMergeStopInProgress] = useState(false);

  const onChangeTab = (_event, tab) => {
    setActiveTab(tab);
  };

  const renderTabs = () => {
    return (
      <>
        <div className={classes.tabContainer}>
          <Tabs
            value={activeTab}
            onChange={onChangeTab}
            textColor="primary"
            classes={{ indicator: classes.tabIndicator }}>
            <Tab
              label="Merge Stops"
              value={appConstants.MERGE_STOPS_TAB_TYPE.MERGE_STOPS}
              classes={{
                root: classes.tabRoot,
                selected: classes.tabSelected,
                labelContainer: classes.tabLabelContainer
              }}
            />
            {!isDuplicateCustomerTerminalLevelEnabled && (
              <Tab
                label="Shipments"
                value={appConstants.MERGE_STOPS_TAB_TYPE.SHIPMENTS}
                classes={{
                  root: classes.tabRoot,
                  selected: classes.tabSelected,
                  labelContainer: classes.tabLabelContainer
                }}
              />
            )}
          </Tabs>
        </div>
        <Divider className={classes.divider} />
      </>
    );
  };

  const renderContent = () => {
    return (
      <>
        <TabPanel
          value={activeTab}
          index={appConstants.MERGE_STOPS_TAB_TYPE.MERGE_STOPS}
          classes={classes}>
          <MergeStopsDetails
            onClose={onClose}
            selectedStops={selectedStops}
            glEventHub={glEventHub}
            mergeType={mergeType}
            onMergeCompleted={onMergeCompleted}
            mergeStopInProgress={mergeStopInProgress}
            setMergeStopInProgress={setMergeStopInProgress}
            isDuplicateCustomerTerminalLevelEnabled={isDuplicateCustomerTerminalLevelEnabled}
          />
        </TabPanel>
        {!isDuplicateCustomerTerminalLevelEnabled && (
          <TabPanel
            value={activeTab}
            index={appConstants.MERGE_STOPS_TAB_TYPE.SHIPMENTS}
            classes={classes}>
            <ShipmentDetails
              mergeType={mergeType}
              selectedStops={selectedStops}
              mergeStopInProgress={mergeStopInProgress}
              onClose={onClose}
            />
          </TabPanel>
        )}
      </>
    );
  };

  return (
    <div className={classes.container}>
      <Divider className={classes.divider} />
      {renderTabs()}
      {renderContent()}
    </div>
  );
};

export default compose(WithDrawer, withStyles(styles))(MergeStops);
